import React from 'react';
import { Col, Form, Select } from 'antd';
import { I18n } from '@aws-amplify/core';

import { RequiredLabel } from './RequiredLabel';
import { OptionType } from './KinebotStepKey/types';
import { CustomFormItem } from './KinebotStepKey/styles';
import { usePersonalisedReportContext } from '../../context';
import { AntdDropdownOption, DropdownOptions } from '../../context/types';

const { useFormInstance, useWatch } = Form;

interface ConsequencesProps {
	stepKeyFieldName: string[];
	mapDropdownOptions: (options: DropdownOptions) => AntdDropdownOption[];
}

export const Consequences: React.FC<ConsequencesProps> = ({ stepKeyFieldName, mapDropdownOptions }) => {
	const form = useFormInstance();
	const { consequencesData } = usePersonalisedReportContext();

	const fieldName = [...stepKeyFieldName, 'consequence_id'];
	const consequenceId = useWatch(fieldName, form);

	function handleConsequenceSelect(id: string): void {
		form.setFieldValue(fieldName, id);
	}

	function handleClearConsequence(): void {
		form.setFieldValue(fieldName, undefined);
	}

	function filterOption(option: OptionType, input: string): boolean {
		return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase());
	}

	return (
		<Col xs={24} sm={12} lg={24}>
			<CustomFormItem
				name={fieldName}
				label={<RequiredLabel title="Consequence" isRequired={true} />}
				labelCol={{ span: 24 }}
				rules={[
					{
						required: true,
						message: I18n.get('Select the consequence')
					}
				]}
			>
				<Select
					showSearch
					allowClear
					size="large"
					value={consequenceId}
					onClear={handleClearConsequence}
					placeholder={I18n.get('Consequence')}
					disabled={consequencesData.errorGettingConsequences}
					onChange={(value: string) => handleConsequenceSelect(value)}
					filterOption={(input, option) => filterOption(option, input)}
					options={mapDropdownOptions(consequencesData.consequences)}
					loading={consequencesData.gettingConsequences || consequencesData.fetchingConsequences}
				/>
			</CustomFormItem>
		</Col>
	);
};
